<template>
  <router-link :to="url + '#_'">
    {{ title }}
  </router-link>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ""
      },
      url: {
        type: String,
        default: ""
      }
    }
  }
</script>
